import React, { Component } from 'react';
import './style.css';
import logo from '../../logo.svg';
import { PageNotFound, Interview } from '../../components';
import { Route, Switch } from 'react-router-dom';
import DataApi from '../../DataApi';
import { URL_START, INTERVIEW_TYPE } from '../../constants';
import Context from '../../context';
import { changeLanguage } from 'i18next';

class App extends Component {
  state = {};

  fetchData() {
    fetch(
      process.env.REACT_APP_API_URL +
        '/backend/package/project/api/' +
        this.props.match.params.project +
        '/?format=json'
    )
      .then(res => res.json())
      .then(data => {
        console.log(data);
        const api = new DataApi(data, INTERVIEW_TYPE);
        data = api.setupData();
        this.setState(data);
        sessionStorage.setItem('interview', JSON.stringify(data));
      });
  }

  componentWillMount() {
    let cached = sessionStorage.getItem('interview');
    if (cached) cached = JSON.parse(cached);
    if (cached && cached.interviewType === INTERVIEW_TYPE) {
      this.setState(cached);
    } else {
      this.fetchData();
    }
  }

  render() {
    if (this.state.objectPairs) {
      return (
        <div className="container-fluid">
          <div className="header">
            <img src={logo} alt="logo" />
            <div class="language-selector">
              <button
                className="btn btn-link btn-sm text-muted"
                onClick={() => changeLanguage('nl')}
              >
                NL
              </button>
              <button
                className="btn btn-link btn-sm text-muted"
                onClick={() => changeLanguage('de')}
              >
                DE
              </button>
              <button
                className="btn btn-link btn-sm text-muted"
                onClick={() => changeLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
          <div class="interview-container">
            <Switch>
              <Route
                path={URL_START + '/:project/'}
                render={({ match }) => (
                  <Context.Provider
                    value={{
                      url:
                        URL_START + '/' + this.props.match.params.project + '/'
                    }}
                  >
                    <Interview {...this.state} />
                  </Context.Provider>
                )}
              />
              <Route path="*" component={PageNotFound} />
            </Switch>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/comparison-new/containers/App/index.jsx